import React, { useEffect, useState } from "react";
import {
  Collapse,
  Input,
  Badge,
  Dialog,
  TextField,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import DisclosureTable from "./DisclosureTable";
import DisclosureSelection from "./DisclosureSelection";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import "./DisclosureCollapse.scss";
import InfoIcon from "@mui/icons-material/Info";
import { green } from "../../../constants/colorConstants";
import { griInfo } from "./griInfo";
import { gstcInfo } from "./gstcInfo";
import { topics33 } from "./griData";
import { brsrSectionInfo } from "./brsrInfo";

const DisclosureCollapse = (props: any) => {
  let [openDialog, setOpenDialog] = useState(false);
  let [infoText, setInfoText] = useState<any>("");
  let [open, setOpen] = useState(false);
  const handleInput = (e: any, object: any, name: any, index: any) => {
    object[name][index] = e.target.value;
    props.update();
  };

  const openDisclosureDialog = (infoText: any) => {
    setOpenDialog(true);
    setInfoText(infoText);
  };

  const handleClose = () => {
    setShowFileUpload(false);
  };

  let [selectedDisclosureTopic, setSelectedDisclosureTopic] = useState("");

  const handleSelectedDisclosureTopic = (topic: string, object: any) => {
    if (!object[topic]) {
      object[topic] = JSON.parse(JSON.stringify(topics33));
    }
    setSelectedDisclosureTopic(topic);
    props.update();
  };

  useEffect(() => {
    if (props.disclosure["3-3 Management of material topics"]) {
      let keys = Object.keys(
        props.disclosure["3-3 Management of material topics"]["topics"]
      );
      keys.forEach((topic) => {
        if (!props.disclosuresArray.slice(2).includes(topic)) {
          delete props.disclosure["3-3 Management of material topics"][
            "topics"
          ][topic];
        }
      });
      props.update();
    }
  }, [props.disclosuresArray]);

  const deleteComment = (object: any) => {
    object["comments"] = {
      reason: "",
      reasonType: "",
    };
    props.update();
  };

  const addComments = (object: any, e: any) => {
    if (props.reportName == "gri") {
      if (typeof object.comments == "string") {
        object["comments"] = {
          reason: "",
          reasonType: "",
        };
      }
      object["comments"]["reason"] = e.target.value;
    } else {
      object["comments"] = e.target.value;
    }
    props.update();
  };
  const addCommentsReasonType = (object: any, e: any) => {
    if (typeof object.comments == "string") {
      object["comments"] = {
        reason: object.comments,
        reasonType: "",
      };
    }
    object["comments"]["reasonType"] = e.target.value;
    props.update();
  };

  const handleFileUpload = (object: any, attachments: any) => {
    object["attachments"] = attachments;
    props.update();
  };

  const setInfoLink = (code: string) => {
    if (code == "GRI 2") {
      setGriPdfLink(
        "https://cms-asset-files.s3.ap-southeast-1.amazonaws.com/gri/GRI+2-General-Disclosures-2021.pdf"
      );
    } else if (code === "GRI 3") {
      setGriPdfLink(
        "https://cms-asset-files.s3.ap-southeast-1.amazonaws.com/gri/GRI+3-Material-Topics-2021.pdf"
      );
    }
    setOpenParentDialog(true);
  };

  let [currentAttachmentForm, setCurrentAttachmentForm] = useState<any>({});
  let [showFileUpload, setShowFileUpload] = useState(false);

  const openAttachments = (form: any) => {
    setCurrentAttachmentForm(form);
    setShowFileUpload(true);
  };
  let [openParentDialog, setOpenParentDialog] = useState(false);
  let [griPdfLink, setGriPdfLink] = useState("");
  let [currentComment, setCurrentComment] = useState("");
  const onClickShowComments = (section: any) => {
    if (currentComment == section) {
      setCurrentComment("");
    } else {
      setCurrentComment(section);
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    inputType: string
  ) => {
    if (
      inputType === "number" &&
      (e.key === "ArrowUp" || e.key === "ArrowDown")
    ) {
      e.preventDefault();
    }
  };

  return Object.keys(props.disclosure).length ? (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className="pw-cursor-pointer gap-3 flex flex-row"
          onClick={() => setOpen(!open)}
        >
          <div>
            {open ? (
              <RemoveCircleOutlineIcon
                style={{
                  fontSize: "17px",
                  color: "#59ce90",
                  marginTop: "-2.75px",
                }}
              />
            ) : (
              <AddCircleOutlineIcon
                style={{
                  fontSize: "17px",
                  color: "#59ce90",
                  marginTop: "-2.75px",
                }}
              />
            )}
          </div>
          <strong style={{ fontSize: "1.1rem" }}>{props.disclosureName}</strong>
        </div>
        <div>
          {["GRI 2", "GRI 3"].includes(props.disclosureName.split(":")[0]) ? (
            // <a
            //   href="https://www.globalreporting.org/how-to-use-the-gri-standards/gri-standards-english-language/"
            //   target="_blank"
            // >
            <IconButton
              onClick={(e) => setInfoLink(props.disclosureName.split(":")[0])}
              className="pw-cursor-pointer"
            >
              <InfoIcon sx={{ color: green[500] }} />
            </IconButton>
          ) : (
            // </a>
            ""
          )}
        </div>
      </div>
      <Collapse in={open}>
        {Object.keys(props.disclosure).map((subSection1, index) => {
          return (
            <div
              key={subSection1 + index}
              style={{ paddingLeft: "2vw", paddingTop: "2vh" }}
            >
              <div
                style={{ marginBottom: "2vh" }}
                className="pw-disclosure-collapse"
              >
                <strong style={{ fontSize: "1rem" }}>{subSection1}</strong>
                &nbsp; &nbsp;
                <img
                  style={{ display: "inline" }}
                  className="pw-cursor-pointer"
                  onClick={() => {
                    onClickShowComments(subSection1);
                  }}
                  src="assets/icons/comment-processing-outline.svg"
                  alt=" "
                />
                &nbsp;
                <span className="pw-cursor-pointer">
                  <Badge
                    onClick={(e) =>
                      openAttachments(props.disclosure[subSection1])
                    }
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    className={
                      props.disclosure[subSection1].attachments?.length
                        ? "pw-badge-primary"
                        : "pw-badge-disabled"
                    }
                    badgeContent={
                      props.disclosure[subSection1].attachments?.length
                    }
                  >
                    <AttachFileIcon />
                  </Badge>
                </span>
                {griInfo[
                  subSection1.split(" ")[0].includes("306")
                    ? subSection1.split(" ")[0] +
                      (props.disclosureName.includes("2020")
                        ? "-2020"
                        : "-2016")
                    : subSection1.split(" ")[0]
                ] != undefined ? (
                  <IconButton
                    className="pw-cursor-pointer"
                    onClick={(e) =>
                      openDisclosureDialog(
                        griInfo[
                          subSection1.split(" ")[0].includes("306")
                            ? subSection1.split(" ")[0] +
                              (props.disclosureName.includes("2020")
                                ? "-2020"
                                : "-2016")
                            : subSection1.split(" ")[0]
                        ]
                      )
                    }
                  >
                    <InfoIcon sx={{ color: green[500] }} />
                  </IconButton>
                ) : (
                  ""
                )}
                {props.reportName === "gstc" &&
                gstcInfo[props.disclosureName.split(" ")[0]][
                  subSection1.split(" ")[0]
                ] != undefined ? (
                  <IconButton
                    className="pw-cursor-pointer"
                    onClick={(e) =>
                      openDisclosureDialog(
                        gstcInfo[props.disclosureName.split(" ")[0]][
                          subSection1.split(" ")[0]
                        ]
                      )
                    }
                  >
                    <InfoIcon sx={{ color: green[500] }} />
                  </IconButton>
                ) : (
                  ""
                )}
                <div>
                  {currentComment == subSection1 ? (
                    <div
                      className="flex justify-between w-10/12"
                      style={{ marginTop: "10px" }}
                    >
                      {props.reportName == "gri" &&
                      ![
                        "2-1",
                        "2-2",
                        "2-3",
                        "2-4",
                        "2-5",
                        "3-1",
                        "3-2",
                      ].includes(subSection1.split(" ")[0]) ? (
                        <FormControl style={{ width: "20%" }}>
                          <InputLabel>Omission Reason Type</InputLabel>
                          <Select
                            onChange={(e) =>
                              addCommentsReasonType(
                                props.disclosure[subSection1],
                                e
                              )
                            }
                            label="Omission Reason Type"
                            value={
                              props.disclosure[subSection1].comments.reasonType
                            }
                          >
                            <MenuItem value="Not applicable">
                              Not applicable
                            </MenuItem>
                            <MenuItem value="Legal prohibitions">
                              Legal prohibitions
                            </MenuItem>
                            <MenuItem value="Confidentiality constraints">
                              Confidentiality constraints
                            </MenuItem>
                            <MenuItem value="Information unavailable / incomplete">
                              Information unavailable / incomplete
                            </MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        ""
                      )}
                      <TextField
                        onChange={(e) =>
                          addComments(props.disclosure[subSection1], e)
                        }
                        type="text"
                        multiline
                        variant="outlined"
                        value={
                          props.disclosure[subSection1].comments?.reason ==
                          undefined
                            ? props.disclosure[subSection1].comments
                            : props.disclosure[subSection1].comments.reason
                        }
                        style={{ width: "75%" }}
                        className="pw-width-100"
                        placeholder="Add comment"
                      />
                      <IconButton
                        onClick={(e) =>
                          deleteComment(props.disclosure[subSection1])
                        }
                      >
                        <DeleteOutlinedIcon
                          sx={{ color: "red", cursor: "pointer" }}
                        />
                      </IconButton>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {Object.keys(props.disclosure[subSection1]).map((subSection2) => {
                const inputType = props.disclosure[subSection1][subSection2][0];
                return subSection2 != "comments" &&
                  subSection2 != "attachments" ? (
                  subSection2 == "topics" ? (
                    <>
                      {/* Material topics 3-3 */}
                      <FormControl style={{ width: "20%" }}>
                        <InputLabel>Select material topic</InputLabel>
                        <Select
                          onChange={(e) =>
                            handleSelectedDisclosureTopic(
                              e.target.value,
                              props.disclosure[subSection1][subSection2]
                            )
                          }
                          label="Select Disclosure"
                          value={selectedDisclosureTopic}
                        >
                          {props.disclosuresArray
                            .slice(2)
                            .sort()
                            .map((eachTopic: any) => (
                              <MenuItem value={eachTopic}>{eachTopic}</MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      {selectedDisclosureTopic ? (
                        <>
                          {Object.keys(
                            props.disclosure[subSection1][subSection2][
                              selectedDisclosureTopic
                            ]
                          ).map((eachQuestion: any) => {
                            return props.disclosure[subSection1][subSection2][
                              selectedDisclosureTopic
                            ][eachQuestion] instanceof Array ? (
                              <>
                                <div
                                  style={{
                                    paddingLeft: "2vw",
                                    marginTop: "2vh",
                                  }}
                                >
                                  <div>{eachQuestion}</div>
                                  <Input
                                    multiline={inputType == "text"}
                                    type={inputType}
                                    value={
                                      props.disclosure[subSection1][
                                        subSection2
                                      ][selectedDisclosureTopic][
                                        eachQuestion
                                      ][1]
                                    }
                                    onChange={(e) =>
                                      handleInput(
                                        e,
                                        props.disclosure[subSection1][
                                          subSection2
                                        ][selectedDisclosureTopic],
                                        eachQuestion,
                                        1
                                      )
                                    }
                                    onKeyDown={(
                                      e: React.KeyboardEvent<HTMLInputElement>
                                    ) => handleKeyDown(e, inputType)}
                                    style={{
                                      marginBottom: "2vh",
                                      width: "50vw",
                                    }}
                                    sx={{
                                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                    inputProps={
                                      inputType === "number" ? { min: 0 } : {}
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <div
                                style={{ paddingLeft: "2vw", marginTop: "2vh" }}
                              >
                                <div>{eachQuestion}</div>
                                {Object.keys(
                                  props.disclosure[subSection1][subSection2][
                                    selectedDisclosureTopic
                                  ][eachQuestion]
                                ).map((subQuestion) => {
                                  return (
                                    <>
                                      <div
                                        style={{
                                          paddingLeft: "2vw",
                                          marginTop: "2vh",
                                        }}
                                      >
                                        <div>{subQuestion}</div>
                                        <Input
                                          multiline={inputType == "text"}
                                          type={inputType}
                                          value={
                                            props.disclosure[subSection1][
                                              subSection2
                                            ][selectedDisclosureTopic][
                                              eachQuestion
                                            ][subQuestion][1]
                                          }
                                          onChange={(e) =>
                                            handleInput(
                                              e,
                                              props.disclosure[subSection1][
                                                subSection2
                                              ][selectedDisclosureTopic][
                                                eachQuestion
                                              ],
                                              subQuestion,
                                              1
                                            )
                                          }
                                          onKeyDown={(
                                            e: React.KeyboardEvent<HTMLInputElement>
                                          ) => handleKeyDown(e, inputType)}
                                          style={{
                                            marginBottom: "2vh",
                                            width: "50vw",
                                          }}
                                          sx={{
                                            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                              {
                                                display: "none",
                                              },
                                            "& input[type=number]": {
                                              MozAppearance: "textfield",
                                            },
                                          }}
                                          inputProps={
                                            inputType === "number"
                                              ? { min: 0 }
                                              : {}
                                          }
                                        />
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <div
                      key={subSection2 + index}
                      style={{ paddingLeft: "2vw" }}
                    >
                      <div
                        style={{ marginBottom: "2vh" }}
                        className="pw-disclosure-collapse"
                      >
                        {(props.reportName == "gstc" &&
                          subSection1.slice(0, 1) === "D") ||
                        props.disclosureName.split(" ")[0] === "Destinations" ||
                        subSection1.slice(0, 2) === "A7" ||
                        (props.reportName == "brsr" &&
                          [
                            "I. Essential Indicators",
                            "II. Leadership Indicators",
                          ].includes(subSection2)) ? (
                          <>
                            <strong>{subSection2}</strong>
                            &nbsp; &nbsp;
                            <img
                              style={{ display: "inline" }}
                              className="pw-cursor-pointer"
                              onClick={() => {
                                onClickShowComments(subSection2);
                              }}
                              src="assets/icons/comment-processing-outline.svg"
                              alt=" "
                            />
                            &nbsp;
                            <span className="pw-cursor-pointer">
                              <Badge
                                onClick={(e) =>
                                  openAttachments(
                                    props.disclosure[subSection1][subSection2]
                                  )
                                }
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                className={
                                  props.disclosure[subSection1][subSection2]
                                    .attachments?.length
                                    ? "pw-badge-primary"
                                    : "pw-badge-disabled"
                                }
                                badgeContent={
                                  props.disclosure[subSection1][subSection2]
                                    .attachments?.length
                                }
                              >
                                <AttachFileIcon />
                              </Badge>
                              {props.reportName === "gstc" &&
                              gstcInfo[props.disclosureName.split(" ")[0]][
                                subSection2.split(" ")[0]
                              ] != undefined ? (
                                <IconButton
                                  className="pw-cursor-pointer"
                                  onClick={(e) =>
                                    openDisclosureDialog(
                                      gstcInfo[
                                        props.disclosureName.split(" ")[0]
                                      ][subSection2.split(" ")[0]]
                                    )
                                  }
                                >
                                  <InfoIcon sx={{ color: green[500] }} />
                                </IconButton>
                              ) : (
                                ""
                              )}
                            </span>
                          </>
                        ) : (
                          <>{subSection2}</>
                        )}
                        {props.reportName == "brsr" ? (
                          brsrSectionInfo[props.disclosureName.split(":")[0]][
                            subSection2.split(".")[0]
                          ] ? (
                            <IconButton
                              className="pw-cursor-pointer"
                              onClick={(e) =>
                                openDisclosureDialog(
                                  brsrSectionInfo[
                                    props.disclosureName.split(":")[0]
                                  ][subSection2.split(".")[0]]
                                )
                              }
                            >
                              <InfoIcon sx={{ color: green[500] }} />
                            </IconButton>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                      <div>
                        {currentComment == subSection2 ? (
                          <div
                            className="flex justify-between w-10/12"
                            style={{ marginTop: "10px" }}
                          >
                            {props.reportName == "gri" &&
                            ![
                              "2-1",
                              "2-2",
                              "2-3",
                              "2-4",
                              "2-5",
                              "3-1",
                              "3-2",
                            ].includes(subSection1.split(" ")[0]) ? (
                              <FormControl style={{ width: "20%" }}>
                                <InputLabel>Reason Type</InputLabel>
                                <Select
                                  onChange={(e) =>
                                    addCommentsReasonType(
                                      props.disclosure[subSection1],
                                      e
                                    )
                                  }
                                  label="Reason Type"
                                  value={
                                    props.disclosure[subSection1].comments
                                      .reasonType
                                  }
                                >
                                  <MenuItem value="Not applicable">
                                    Not applicable
                                  </MenuItem>
                                  <MenuItem value="Legal prohibitions">
                                    Legal prohibitions
                                  </MenuItem>
                                  <MenuItem value="Confidentiality constraints">
                                    Confidentiality constraints
                                  </MenuItem>
                                  <MenuItem value="Information unavailable / incomplete">
                                    Information unavailable / incomplete
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            ) : (
                              ""
                            )}
                            <TextField
                              onChange={(e) =>
                                addComments(
                                  props.disclosure[subSection1][subSection2],
                                  e
                                )
                              }
                              type="text"
                              multiline
                              variant="outlined"
                              value={
                                props.disclosure[subSection1][subSection2]
                                  .comments?.reason == undefined
                                  ? props.disclosure[subSection1][subSection2]
                                      .comments
                                  : props.disclosure[subSection1][subSection2]
                                      .comments.reason
                              }
                              style={{ marginTop: "10px" }}
                              className="pw-width-100"
                              placeholder="Add comment"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {Object.keys(props.disclosure[subSection1][subSection2])
                        .length ? (
                        typeof props.disclosure[subSection1][subSection2][1] !==
                          "string" &&
                        !Array.isArray(
                          props.disclosure[subSection1][subSection2][1]
                        ) ? (
                          <div style={{ marginTop: "2vh" }}>
                            {Object.keys(
                              props.disclosure[subSection1][subSection2]
                            ).map((subSection3, index) => {
                              const inputType =
                                props.disclosure[subSection1][subSection2][
                                  subSection3
                                ][0];
                              return subSection3 != "comments" &&
                                subSection3 != "attachments" ? (
                                <div
                                  key={subSection3 + index}
                                  style={{ paddingLeft: "2vw" }}
                                >
                                  <div>
                                    {subSection3}
                                    {props.reportName == "brsr" ? (
                                      brsrSectionInfo[
                                        props.disclosureName.split(":")[0]
                                      ][subSection1.split(":")[0]] &&
                                      brsrSectionInfo[
                                        props.disclosureName.split(":")[0]
                                      ][subSection1.split(":")[0]][
                                        subSection2
                                      ] &&
                                      brsrSectionInfo[
                                        props.disclosureName.split(":")[0]
                                      ][subSection1.split(":")[0]][subSection2][
                                        subSection3.split(".")[0]
                                      ] ? (
                                        <IconButton
                                          className="pw-cursor-pointer"
                                          onClick={(e) =>
                                            openDisclosureDialog(
                                              brsrSectionInfo[
                                                props.disclosureName.split(
                                                  ":"
                                                )[0]
                                              ][subSection1.split(":")[0]][
                                                subSection2
                                              ][subSection3.split(".")[0]]
                                            )
                                          }
                                        >
                                          <InfoIcon
                                            sx={{ color: green[500] }}
                                          />
                                        </IconButton>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  {typeof inputType !== "string" ? (
                                    Object.keys(
                                      props.disclosure[subSection1][
                                        subSection2
                                      ][subSection3]
                                    ).map((subSection4) => {
                                      const inputType =
                                        props.disclosure[subSection1][
                                          subSection2
                                        ][subSection3][subSection4][0];
                                      return (
                                        <div
                                          key={subSection4 + index}
                                          style={{ paddingLeft: "2vw" }}
                                        >
                                          <div>{subSection4}</div>

                                          {typeof inputType !== "string" ? (
                                            Object.keys(
                                              props.disclosure[subSection1][
                                                subSection2
                                              ][subSection3][subSection4]
                                            ).map((subSection5) => {
                                              const inputType =
                                                props.disclosure[subSection1][
                                                  subSection2
                                                ][subSection3][subSection4][
                                                  subSection5
                                                ][0];
                                              return (
                                                <div
                                                  key={subSection5 + index}
                                                  style={{ paddingLeft: "2vw" }}
                                                >
                                                  <div>{subSection5}</div>
                                                  {typeof inputType !==
                                                  "string" ? (
                                                    Object.keys(
                                                      props.disclosure[
                                                        subSection1
                                                      ][subSection2][
                                                        subSection3
                                                      ][subSection4][
                                                        subSection5
                                                      ]
                                                    ).map((subSection6) => {
                                                      const inputType =
                                                        props.disclosure[
                                                          subSection1
                                                        ][subSection2][
                                                          subSection3
                                                        ][subSection4][
                                                          subSection5
                                                        ][subSection6][0];
                                                      return (
                                                        <div
                                                          key={
                                                            subSection6 + index
                                                          }
                                                          style={{
                                                            paddingLeft: "2vw",
                                                          }}
                                                        >
                                                          <div>
                                                            {subSection6}
                                                          </div>
                                                          {inputType ==
                                                            "table" ||
                                                          inputType ==
                                                            "fixed_table" ? (
                                                            <DisclosureTable
                                                              update={
                                                                props.update
                                                              }
                                                              value={
                                                                props
                                                                  .disclosure[
                                                                  subSection1
                                                                ][subSection2][
                                                                  subSection3
                                                                ][subSection4][
                                                                  subSection5
                                                                ][subSection6]
                                                              }
                                                              disclosuresArray={
                                                                props.disclosuresArray
                                                              }
                                                            ></DisclosureTable>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                      );
                                                    })
                                                  ) : inputType == "table" ||
                                                    inputType ==
                                                      "fixed_table" ? (
                                                    <DisclosureTable
                                                      update={props.update}
                                                      value={
                                                        props.disclosure[
                                                          subSection1
                                                        ][subSection2][
                                                          subSection3
                                                        ][subSection4][
                                                          subSection5
                                                        ]
                                                      }
                                                      disclosuresArray={
                                                        props.disclosuresArray
                                                      }
                                                    ></DisclosureTable>
                                                  ) : (
                                                    <Input
                                                      multiline={
                                                        inputType == "text"
                                                      }
                                                      type={inputType}
                                                      value={
                                                        props.disclosure[
                                                          subSection1
                                                        ][subSection2][
                                                          subSection3
                                                        ][subSection4][1]
                                                      }
                                                      onChange={(e) =>
                                                        handleInput(
                                                          e,
                                                          props.disclosure[
                                                            subSection1
                                                          ][subSection2][
                                                            subSection3
                                                          ][subSection4],
                                                          subSection5,
                                                          1
                                                        )
                                                      }
                                                      onKeyDown={(
                                                        e: React.KeyboardEvent<HTMLInputElement>
                                                      ) =>
                                                        handleKeyDown(
                                                          e,
                                                          inputType
                                                        )
                                                      }
                                                      style={{
                                                        marginBottom: "2vh",
                                                        width: "50vw",
                                                      }}
                                                      sx={{
                                                        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                                          {
                                                            display: "none",
                                                          },
                                                        "& input[type=number]":
                                                          {
                                                            MozAppearance:
                                                              "textfield",
                                                          },
                                                      }}
                                                      inputProps={
                                                        inputType === "number"
                                                          ? { min: 0 }
                                                          : {}
                                                      }
                                                    />
                                                  )}
                                                </div>
                                              );
                                            })
                                          ) : inputType == "table" ||
                                            inputType == "fixed_table" ? (
                                            <DisclosureTable
                                              update={props.update}
                                              value={
                                                props.disclosure[subSection1][
                                                  subSection2
                                                ][subSection3][subSection4]
                                              }
                                              disclosuresArray={
                                                props.disclosuresArray
                                              }
                                            ></DisclosureTable>
                                          ) : (
                                            <Input
                                              multiline={inputType == "text"}
                                              type={inputType}
                                              value={
                                                props.disclosure[subSection1][
                                                  subSection2
                                                ][subSection3][1]
                                              }
                                              onChange={(e) =>
                                                handleInput(
                                                  e,
                                                  props.disclosure[subSection1][
                                                    subSection2
                                                  ][subSection3],
                                                  subSection4,
                                                  1
                                                )
                                              }
                                              onKeyDown={(
                                                e: React.KeyboardEvent<HTMLInputElement>
                                              ) => handleKeyDown(e, inputType)}
                                              style={{
                                                marginBottom: "2vh",
                                                width: "50vw",
                                              }}
                                              sx={{
                                                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                                  {
                                                    display: "none",
                                                  },
                                                "& input[type=number]": {
                                                  MozAppearance: "textfield",
                                                },
                                              }}
                                              inputProps={
                                                inputType === "number"
                                                  ? { min: 0 }
                                                  : {}
                                              }
                                            />
                                          )}
                                        </div>
                                      );
                                    })
                                  ) : inputType == "table" ||
                                    inputType == "fixed_table" ? (
                                    <DisclosureTable
                                      update={props.update}
                                      value={
                                        props.disclosure[subSection1][
                                          subSection2
                                        ][subSection3]
                                      }
                                      disclosuresArray={props.disclosuresArray}
                                    ></DisclosureTable>
                                  ) : (
                                    <>
                                      <Input
                                        multiline={inputType == "text"}
                                        type={inputType}
                                        value={
                                          props.disclosure[subSection1][
                                            subSection2
                                          ][subSection3][1]
                                        }
                                        onChange={(e) =>
                                          handleInput(
                                            e,
                                            props.disclosure[subSection1][
                                              subSection2
                                            ],
                                            subSection3,
                                            1
                                          )
                                        }
                                        onKeyDown={(
                                          e: React.KeyboardEvent<HTMLInputElement>
                                        ) => handleKeyDown(e, inputType)}
                                        style={{
                                          marginBottom: "2vh",
                                          width: "50vw",
                                        }}
                                        sx={{
                                          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                            {
                                              display: "none",
                                            },
                                          "& input[type=number]": {
                                            MozAppearance: "textfield",
                                          },
                                        }}
                                        inputProps={
                                          inputType === "number"
                                            ? { min: 0 }
                                            : {}
                                        }
                                      />
                                      {props.disclosure[subSection1][
                                        subSection2
                                      ][subSection3][2] != undefined ? (
                                        <Select
                                          variant="standard"
                                          onChange={(e) =>
                                            handleInput(
                                              e,
                                              props.disclosure[subSection1][
                                                subSection2
                                              ],
                                              subSection3,
                                              2
                                            )
                                          }
                                          value={
                                            props.disclosure[subSection1][
                                              subSection2
                                            ][subSection3][2]
                                          }
                                        >
                                          <MenuItem value="joules">
                                            Joules
                                          </MenuItem>
                                          <MenuItem value="watt hours">
                                            Watt hours
                                          </MenuItem>
                                        </Select>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </div>
                              ) : (
                                ""
                              );
                            })}
                          </div>
                        ) : inputType == "table" ||
                          inputType == "fixed_table" ? (
                          <DisclosureTable
                            update={props.update}
                            value={props.disclosure[subSection1][subSection2]}
                            disclosuresArray={props.disclosuresArray}
                          />
                        ) : inputType == "array" ? (
                          <DisclosureSelection
                            disclosuresArray={props.disclosuresArray}
                            setDisclosuresArray={props.setDisclosuresArray}
                            allDisclosures={Object.keys(props.disclosures)}
                            update={props.update}
                            value={props.disclosure[subSection1][subSection2]}
                          />
                        ) : (
                          <Input
                            multiline={inputType == "text"}
                            type={inputType}
                            value={
                              props.disclosure[subSection1][subSection2][1]
                            }
                            onChange={(e) =>
                              handleInput(
                                e,
                                props.disclosure[subSection1],
                                subSection2,
                                1
                              )
                            }
                            onKeyDown={(
                              e: React.KeyboardEvent<HTMLInputElement>
                            ) => handleKeyDown(e, inputType)}
                            style={{ marginBottom: "2vh", width: "50vw" }}
                            sx={{
                              "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                {
                                  display: "none",
                                },
                              "& input[type=number]": {
                                MozAppearance: "textfield",
                              },
                            }}
                            inputProps={
                              inputType === "number" ? { min: 0 } : {}
                            }
                          />
                        )
                      ) : null}
                    </div>
                  )
                ) : (
                  ""
                );
              })}
            </div>
          );
        })}
      </Collapse>

      <Dialog open={openParentDialog} className="pw-disclosure-dialog">
        <div
          onClick={(e) => setOpenParentDialog(false)}
          style={{
            cursor: "pointer",
            textAlign: "right",
            marginTop: "5px",
          }}
        >
          <CancelIcon />
        </div>
        <div style={{ height: "90vh" }}>
          <iframe
            width="100%"
            height="100%"
            src={griPdfLink + "#toolbar=0&view=FItH"}
          ></iframe>
        </div>
      </Dialog>
      <Dialog open={showFileUpload} className="pw-attachment-dialog">
        <div className="pb-6">
          <div className="pw-header-text">Add attachments</div>
          <div
            onClick={handleClose}
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginTop: "-30px",
              // padding: "10px",
            }}
          >
            <CancelIcon />
          </div>
          <FileAttachmentsDetails
            formData={currentAttachmentForm}
            setFormData={(formData: any) =>
              handleFileUpload(currentAttachmentForm, formData.attachments)
            }
          ></FileAttachmentsDetails>
        </div>
      </Dialog>

      <Dialog open={openDialog} className="pw-disclosure-dialog">
        <div
          onClick={(e) => setOpenDialog(false)}
          style={{
            cursor: "pointer",
            textAlign: "right",
            marginTop: "5px",
          }}
        >
          <CancelIcon />
        </div>
        {/* <iframe  width="100%" height="100%" > */}
        <div
          style={{ lineHeight: "1.5rem", padding: "0px 20px 20px 20px" }}
          dangerouslySetInnerHTML={{ __html: infoText }}
        ></div>
        {/* </iframe> */}
      </Dialog>
    </div>
  ) : (
    <div></div>
  );
};

export default DisclosureCollapse;
